module.exports = __webpack_public_path__ + "img/sku-detail-bg.ffc7610.png";